<mat-toolbar>
  <mat-toolbar-row class="top-row">
    <div class="breadcrumb">
      <a routerLink="/"><mat-icon>home</mat-icon> Home </a>
      <span>/</span>
      <span>{{breadcrumb1}}</span>
      <span>/</span>
      <span><strong>{{breadcrumb2}}</strong></span>
    </div>
  </mat-toolbar-row>
  <mat-toolbar-row>
    <h1>
      <span class="title">{{title1}}</span> <span class="subtitle">{{title2}}</span>
      <app-help-icon-button [code]="code"></app-help-icon-button>
    </h1>
  </mat-toolbar-row>
</mat-toolbar>
